var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"button",staticClass:"gh-go-to-rego",on:{"click":_vm.goToRego}},[_vm._v("\n    REGISTER\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }